(function () {
    'use strict';

    angular.module('ib-pmt-mmb-confirmation-module')
        .component('ibConfirmationMMB', {
            controller: 'ConfirmationMMboController',
            controllerAs: 'cMMbCtrl',
            bindings: {
                model: '=',
                asComponent: '<'
            },
            templateUrl: ['$rootScope', function ($rootScope) {
                return $rootScope.routes.templates + 'ib-pmt-mmb-confirmation-view.html';
            }]
        });

})();